module.exports = __webpack_public_path__ + "static/img/score_7.d76bd52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/score/score_7.jpg
// module id = /duO
// module chunks = 0